import styled from '@emotion/styled/macro';
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { imageOnError } from '../../helpers';
import {
  FONT_STYLE,
  PLACEHOLDER_IMAGE,
  SETTINGS,
  THEME_COLORS,
  TRANSITION_DURATION
} from '../../variables';

const Title = styled(Typography)(() => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: '2',
  WebkitBoxOrient: 'vertical',
  transition: `color ${TRANSITION_DURATION}ms ease`,
  fontWeight: FONT_STYLE.bold,
  "text-align": "center"
}));

const VariantsButton = styled(Box)(({ theme }) => ({
  width: '100%',
  position: 'absolute',
  left: 0,
  bottom: theme.spacing(2),
  display: 'flex',
  justifyContent: 'center',
  opacity: 0,
  transition: `opacity ${TRANSITION_DURATION}ms ease`
}));

const ProductCardGrid = styled(Card)(() => ({
  // minWidth: '130px',
  // maxWidth: '300px',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  textDecoration: 'none',
  border: 'none',
  '&:hover': {
    [Title]: {
      color: THEME_COLORS.primary
    },
    [VariantsButton]: {
      opacity: 1
    }
  },
  "border-radius":"8px"
}));

const ImageContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  padding:0,
  // border: `1px solid ${THEME_COLORS.gray}`,
  // padding: theme.spacing(2)
  transition: `opacity ${TRANSITION_DURATION}ms ease`,
  '&:hover': {
    opacity: 0.85
  }
}));

const Image = styled(CardMedia)(() => ({
  maxWidth: '100%',
  objectFit: 'cover',
  aspectRatio: '1'
}));

const Reference = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  color: THEME_COLORS.darkGray,
  "text-align": "center"

}));

const Brand = styled(Typography)(({ theme }) => ({
  fontSize: '.75rem',
  marginBottom: theme.spacing(1)
}));

const Content = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100%',
  padding: `${theme.spacing(1.5)} 0 0 0 !important`
}));


const ProductCustomizeCard = ({ product }) => {

  const { slug, title, brand, images, reference } = product;

  return (
    <ProductCardGrid className="product-card">
      <ImageContainer title={title} to={slug}>
        <Image
          component="img"
          image={images.length !== 0 ? images?.[0] : PLACEHOLDER_IMAGE}
          onError={imageOnError}
          alt={title}
        />
      </ImageContainer>

      <Content>
        <Box sx={{
          "padding":"12px 0 "
        }}>
          {SETTINGS.defaults.productCard.brand && !!brand && (
            <Brand>{brand}</Brand>
          )}
          <Title component={Link} title={title} to={slug}>
            {title}
          </Title>
          {SETTINGS.defaults.productCard.reference && (
            <Reference variant="xsmall">{`Ref: ${reference}`}</Reference>
          )}
        </Box>
      </Content>
    </ProductCardGrid>
  );
};

export default ProductCustomizeCard;
